import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointDesktop,
  BreakPointMobile,
} from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  dialog: {
    gap: theme.spacing.space24,
    [BreakPointMobile]: {
      gap: 0,
    },
  },
  header: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
    padding: `0px ${theme.spacing.space48}px`,
    [BreakPointMobile]: {
      padding: `${theme.spacing.space24}px ${theme.spacing.space16}px`,
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space24,
    width: "-webkit-fill-available",
    padding: `0px ${theme.spacing.space48}px`,
    [BreakPointMobile]: {
      padding: `0px ${theme.spacing.space16}px ${theme.spacing.space4}px ${theme.spacing.space16}px`,
    },
  },
  item: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
    alignItems: "start",
  },
  platforms: {
    display: "flex",
    gap: theme.spacing.space16,
    width: "100%",
    flexWrap: "wrap",
  },
  platformCard: {
    minWidth: "45%",
    boxSizing: "border-box",
    borderRadius: 6,
    background: "linear-gradient(96deg, #000 2.35%, #262626 98.12%)",
    padding: theme.spacing.space8,
    display: "flex",
    gap: theme.spacing.space6,
    alignItems: "center",
    cursor: "pointer",
    [BreakPointDesktop]: {
      minWidth: 158,
    },
  },
  logoIcon: {
    height: 30,
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
  },
  selected: {
    outline: `2px solid ${theme.colors.Border4}`,
    outlineOffset: 2,
  },
  root: {
    paddingLeft: 0,
    paddingRight: 0,
    '& [class*="actions"]': {
      padding: `0px ${theme.spacing.space48}px`,
      [BreakPointMobile]: {
        padding: `${theme.spacing.space24}px ${theme.spacing.space16}px`,
      },
    },
  },
  hideSelect: {
    cursor: "default",
  },
}));
